import React from 'react'
import { Checkbox, Input } from 'antd';
import masterCard from "../../../assets/images/master.png"
import { Link } from "react-router-dom";


const onChange = (e) => {
  console.log(`checked = ${e.target.checked}`);
};

const paymentCard = () => {
  return (
    <div className="payment-card-wrap">
        <div className="payment-card-details">
            <div><img src={masterCard} alt="img" srcset="" /></div>
            <div className="card-number">... ... ... 3074</div>
            <div className="cardholder-name cardholder">John Doe</div>
            <div className="cardholder-expiry cardholder">10/2024</div>
            <div className='cvv'><Input placeholder="CVV" /></div>
            <div><Checkbox onChange={onChange}></Checkbox></div>
            <div><Link to="">Edit</Link></div>
        </div>
    </div>
  )
}

export default paymentCard
